module.exports = __webpack_public_path__ + "static/media/Shiny_Blueprint_App_Recording.4156476b.mp4";